export default "__VITE_ASSET__1d5312f9__"